import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { COLOR } from '../../model/score-card.model';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit, OnChanges {

  @Input() width = 0;
  @Input() color = '';
  @Input() isValue;
  @Input() unit;
  value: string;
  bgColor: string;
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    switch (this.color) {
      case COLOR.RED:
        this.value = '33.33%';
        this.bgColor = COLOR.RED;
        break;
      case COLOR.GREEN:
        this.value = '100%';
        this.bgColor = COLOR.GREEN;
        break;
      case COLOR.ORANGE:
        this.value = '66.66%';
        this.bgColor = COLOR.ORANGE;
        break;
      default: {
        this.bgColor = '';
        this.value = '0%';
      }
    }
  }

  public isNumber(num) {
    return typeof (num) === 'number' ? true : false;
  }

}
